var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "news" }, [
    _c("link", {
      attrs: {
        rel: "stylesheet",
        href: "https://pro.fontawesome.com/releases/v5.14.0/css/all.css",
        integrity:
          "sha384-VhBcF/php0Z/P5ZxlxaEx1GwqTQVIBu4G4giRWxTKOCjTxsPFETUDdVL5B6vYvOt",
        crossorigin: "anonymous",
      },
    }),
    _c("div", { staticClass: "kroppensContainer" }, [
      _c("div", { staticClass: "newsContainer" }, [
        _c(
          "div",
          { staticClass: "articles" },
          [
            this.$root.admin
              ? _c(
                  "p",
                  { staticClass: "heading" },
                  [
                    this.$root.admin
                      ? _c("font-awesome-icon", {
                          class: ["settings", _vm.settingsMode ? "active" : ""],
                          attrs: { icon: ["fas", "cog"] },
                          on: {
                            click: function ($event) {
                              _vm.settingsMode = !_vm.settingsMode
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm.settingsMode && this.$root.admin
              ? _c("settingsComponent", {
                  attrs: {
                    contentid: _vm.contentid,
                    saving: _vm.saving,
                    settings: this.$root.settings,
                  },
                  on: { newSettings: _vm.newSettings },
                })
              : _vm._e(),
            _c(
              "transition-group",
              { attrs: { name: "bounce", tag: "section" } },
              _vm._l(_vm.items, function (item, index) {
                return _c(
                  "article",
                  { key: index + 1, staticClass: "newsItem" },
                  [
                    _c("div", { staticClass: "newsItemInner" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              _vm.basedir +
                              item.urlPrefix +
                              item.url.replace("?", "#"),
                          },
                        },
                        [
                          _c("div", {
                            staticClass: "newsItemImage ingredientImage",
                            style:
                              "background-image: url(" +
                              _vm.basedir +
                              item.imageUrl +
                              "?w=336" +
                              ");",
                          }),
                          _c("div", { staticClass: "contentSnippet" }, [
                            _c(
                              "h5",
                              {
                                style: {
                                  fontSize:
                                    item.headers.length >= 26
                                      ? 1 + "em"
                                      : 1.5 + "em",
                                },
                              },
                              [_vm._v(_vm._s(item.headers))]
                            ),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  item.description.length > 80
                                    ? item.description.slice(0, 80) + "..."
                                    : item.description
                                )
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "readMoreLinkfooterCard" }, [
                            _vm._v(_vm._s(_vm.$root.translations.wsm_ReadMore)),
                          ]),
                          _c(
                            "script",
                            { attrs: { type: "application/ld+json" } },
                            [
                              _vm._v(
                                ' { "@context": "http://schema.org", "@type": "NewsArticle", "mainEntityOfPage": { "@type": "WebPage", "@id": "' +
                                  _vm._s(_vm.location) +
                                  '" }, "headline": ' +
                                  _vm._s(JSON.stringify(item.headers)) +
                                  ', "image": [ "' +
                                  _vm._s(
                                    item.imageUrl.indexOf("http") < 0
                                      ? _vm.location +
                                          _vm.basedir +
                                          item.imageUrl
                                      : item.imageUrl
                                  ) +
                                  '" ], "datePublished": "' +
                                  _vm._s(
                                    new Date(item.publicationDate)
                                      .toISOString()
                                      .slice(0, 10)
                                  ) +
                                  '", "dateModified": "' +
                                  _vm._s(
                                    new Date(item.publicationDate)
                                      .toISOString()
                                      .slice(0, 10)
                                  ) +
                                  '", "author": { "@type": "Organization", "name": "Pharma Nord" }, "publisher": { "@type": "Organization", "name": "Pharma Nord", "logo": { "@type": "ImageObject", "url": "' +
                                  _vm._s(_vm.location + _vm.basedir) +
                                  '/static/CKFinderJava/userfiles/images/2014/general/Logo-PN-no-slogan-0514.png" } }, "description": ' +
                                  _vm._s(JSON.stringify(item.description)) +
                                  " } "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ],
          1
        ),
        _vm.showMore
          ? _c(
              "button",
              {
                staticClass: "loadMoreNews",
                on: {
                  click: function ($event) {
                    _vm.getArticles(
                      parseInt(_vm.items.length) +
                        parseInt(_vm.$root.settings.default)
                    )
                  },
                },
              },
              [
                _c("i", {
                  class: [
                    _vm.loading
                      ? "fad fa-spinner fa-spin"
                      : "fad fa-angle-double-down",
                  ],
                }),
                _vm._v(" " + _vm._s(_vm.$root.translations.wsm_ShowMore)),
              ]
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }